import React from 'react';
import { Form, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import FormControls, { ConditionalRender } from '../../../controls/formControls';

const CustomerAccountForm = (props) => {
    const formHandler = props.formHandler;
    const customer = props.customer;
    return (
        <>
            <Form.Row>
                <Form.Group as={Col} lg="6" md="6" controlId="name">
                    {
                        //props.hasPermission(claims.canCrudAccounts, claimValues.createReadUpdateDelete)
                        true ?
                            <FormControls.Textbox
                                label="Name"
                                name="name"
                                formHandler={formHandler} />
                            : <>
                                <Form.Label>Name</Form.Label>
                                <Form.Control placeholder="" name="name" id="name" plaintext readOnly value={formHandler.values.name} />
                            </>
                    }
                </Form.Group>
                <ConditionalRender visible={formHandler.values.parentAccountId}>
                    <Form.Group as={Col} lg="6" md="6" controlId="name">
                        <Form.Label>Parent Account</Form.Label><br/>
                        <LinkContainer to={`/admin/accounts/${formHandler.values.parentAccountId}`}>
                            <Button variant="link" size="sm">{formHandler.values.parentAccountName}</Button>
                        </LinkContainer>
                    </Form.Group>
                </ConditionalRender>
                <Form.Group as={Col} lg="2" md="6" controlId="">
                    <FormControls.Numberbox
                        label="Customer Number"
                        name="customerNumber"
                        formHandler={formHandler} />
                </Form.Group>

                <Form.Group as={Col} lg="4" md="6" controlId="">
                    <FormControls.ButtonGrouping
                        label="State"
                        name="state"
                        size="sm"
                        variant="secondary"
                        formHandler={formHandler}
                        options={[{ value: 100, name: "Active" }, { value: -50, name: "Suspended" }, { value: -100, name: "Deleted" }]} />
                </Form.Group>
            </Form.Row>
            <ConditionalRender visible={ !customer.isParentAccount }>
                <Form.Row>
                    <Form.Group as={Col} lg="3" md="6" controlId="">
                        <FormControls.SelectBox
                            label="Vendor"
                            name="emrVendorId"
                            numeric
                            formHandler={formHandler}
                            defaultValue={0}
                            showDefault
                            defaultLabel="Select Vendor ..."
                            onChange={(e) => {
                                const val = parseInt(e.target.value);
                                formHandler.setFieldValue("emrVendorId", val, true)
                            }}
                            options={props.vendors}
                        />
                    </Form.Group>
                    <Form.Group as={Col} lg="3" md="6">
                        <FormControls.SelectBox
                            label="Homecare Queue"
                            name="homecareQueueId"
                            numeric
                            formHandler={formHandler}
                            defaultValue={0}
                            showDefault
                            defaultLabel="Select Queue ..."
                            onChange={(e) => {
                                const val = parseInt(e.target.value);
                                formHandler.setFieldValue("homecareQueueId", val, true)
                            }}
                            options={props.queues}
                        />
                    </Form.Group>
                    <Form.Group as={Col} lg="3" md="6">
                        <FormControls.SelectBox
                            label="Hospice Queue"
                            name="hospiceQueueId"
                            numeric
                            formHandler={formHandler}
                            defaultValue={0}
                            showDefault
                            defaultLabel="Select Queue ..."
                            onChange={(e) => {
                                const val = parseInt(e.target.value);
                                formHandler.setFieldValue("hospiceQueueId", val, true)
                            }}
                            options={props.queues}
                        />
                    </Form.Group>
                </Form.Row>
            </ConditionalRender>
        </>
    );
}

export default CustomerAccountForm;